import { Utils } from "@/plugin/gis-viewer/Utils";
import { IFindParameter, IResult, IPointSymbol } from "@/types/map";
import { loadModules } from "esri-loader";
import ArrowLineLayer from "../../ArrowLine/ArrowLineLayer";
import { Bar3DChart } from "../../MigrateChart/arcgis/Bar3DChart";
import { MigrateChart } from "../../MigrateChart/arcgis/MigrateChart";
import { SubwayLine } from "../../MigrateChart/arcgis/SubwayLine";
import HighFeauture2D from "../../Overlays/arcgis/HighFeauture2D";
import HighFeauture3D from "../../Overlays/arcgis/HighFeauture3D";
import ToolTip from "../../Overlays/arcgis/ToolTip";

export class FindFeatureYp {
  private static instances: Map<string, any>;

  private findLayer!: __esri.GraphicsLayer;
  private view!: __esri.MapView | __esri.SceneView;
  private highTime: any;
  private highState: boolean = true;
  private highCount: number = 0;
  private highRepeat: number = 10;
  private tooltips: any[] = [];

  private constructor(view: __esri.MapView | __esri.SceneView) {
    this.view = view;
  }

  public static getInstance(view: __esri.MapView | __esri.SceneView) {
    let id = view.container.id;
    if (!FindFeatureYp.instances) {
      FindFeatureYp.instances = new Map();
    }
    let instance = FindFeatureYp.instances.get(id);
    if (!instance) {
      instance = new FindFeatureYp(view);
      FindFeatureYp.instances.set(id, instance);
    }
    return instance;
  }

  private async createOverlayLayer() {
    type MapModules = [typeof import("esri/layers/GraphicsLayer")];
    const [GraphicsLayer] = await (loadModules(["esri/layers/GraphicsLayer"]) as Promise<MapModules>);
    this.findLayer = new GraphicsLayer();
    this.view.map.add(this.findLayer);
  }
  public async findLayerFeature(params: IFindParameter): Promise<IResult> {
    if (!this.findLayer) {
      await this.createOverlayLayer();
    } else {
      this.findLayer.removeAll();
    }
    this.view.popup.close();
    if (this.tooltips.length > 0) {
      this.tooltips.forEach(tip => {
        tip.remove();
      });
    }
    this.tooltips = [];
    let type = params.layerName;
    let ids = params.ids || [];
    let level = params.level || 0;
    let centerResult = params.centerResult !== false;
    let layerIds = params.layerids || undefined;
    let showPopUp = params.showPopUp !== false;
    let xoffset = params.xoffset || 0;
    let yofffset = params.yoffset || 0;
    let fields = params.fields || undefined;
    let style = params.style || "none";
    let factor = params.factor;
    let color = params.color;
    this.highRepeat = params.repeatCount || 10;
    const hightLightOption = params.highLightOption;
    const noJump = params.noJump || false;

    let allLayers = this.view.map.allLayers;
    let theClusterLayer: any = undefined; //查找到聚合撒点所在的图层
    let results: any = [];
    let config_layer_flag = false;

    for (let i = 0; i < allLayers.length; i++) {
      let layer = allLayers.getItemAt(i) as any;
      if (params.layerName && layer.label === params.layerName) {
        //if (layer.visible) {
        // console.log(i, layer.type, '图层属性');
        if (layer.type == "feature" || layer.type == "map-image") {
          let res = await this.doFindTask({
            url: layer.url as string,
            layer: layer,
            layerIds: layerIds || this.getLayerIds(layer),
            ids: ids,
            layerIndex: i,
            zoom: level,
            factor,
            style,
            color,
            showPopUp: showPopUp,
            offset: { x: xoffset, y: yofffset },
            fields: fields,
            hightLightOption,
          });
          if (res.length > 0 && res[0].length > 0) {
            results = res[0];
            config_layer_flag = true;
            break;
          }
          //如果找到feature或者dynamic,则不再查找
        }
      }
      if (layer.type == "graphics") {
        if (layer.data) {
          //cluster点聚合图层
          let overlays = layer.data;
          overlays.forEach((overlay: any) => {
            if (type == overlay.type && ids.indexOf(overlay.id) >= 0) {
              results.push(overlay);
              theClusterLayer = layer;
            }
          }, this);
        } else if (layer.graphics) {
          //addoverlay撒点图层
          layer.graphics.forEach((overlay: any) => {
            if ((type == overlay.type && ids.indexOf(overlay.id) >= 0) || (overlay.attributes && overlay.attributes.type == type && ids.indexOf(overlay.attributes.id) >= 0)) {
              // results = [overlay];
              results.push(overlay);
              // if (centerResult) {
              //   if (overlay.geometry.type == "point") {
              //     this.view.goTo({
              //       target: overlay.geometry,
              //       zoom: Math.max(this.view.zoom, level),
              //     });
              //   } else {
              //     this.view.goTo({
              //       target: overlay.geometry,
              //     });
              //   }
              // }
              if (overlay.geometry.type == "point") {
                if (overlay.attributes.isClusterText !== true) {
                  // this.startJumpPoint([overlay]); //不要在这里跳！
                }
              } else {
                debugger;
                this.startHighlightOverlays(overlay.geometry, hightLightOption?.color || color || overlay.symbol.color, hightLightOption?.style, hightLightOption?.width, hightLightOption?.fillcolor, hightLightOption);
              }
            }
          }, this);
        }
      }
    }
    //获取查找结果中的撒点和聚合撒点，用于后续跳跃
    const jumpPoints = Array<any>();
    results.forEach((element: any) => {
      // 撒点覆盖物
      if (element.geometry?.type == "point") {
        jumpPoints.push(element);
      }
      //聚合撒点覆盖物
      else if (element.x && element.y) {
        jumpPoints.push(element);
      }
    });
    const that = this;
    // 将查找结果点位显示到地图中间并跳跃
    return new Promise<IResult>(async (resolve, reject) => {
      // 如果是聚合撒点
      if (theClusterLayer != undefined) {
        //不显示到地图中心
        if (!centerResult) {
          that._findClusterPointAndJump(theClusterLayer, type, ids);
          resolve({
            status: 0,
            message: "ok",
            result: results,
          });
          return;
        }
        //显示到地图中心
        await that.view.goTo({
          center: [jumpPoints[0].x, jumpPoints[0].y],
          zoom: Math.max(this.view.zoom, level),
        });
        that._findClusterPointAndJump(theClusterLayer, type, ids);
        resolve({
          status: 0,
          message: "ok",
          result: results,
        });
        return;
      }
      // 如果是图层线，则无需在此处缩放到地图中心
      if (results.length == 1 && centerResult && config_layer_flag) {
        resolve({
          status: 0,
          message: "ok",
          result: results,
        });
        return;
      }
      // 显示 撒点和线 的查找结果到地图中心
      if (results.length > 0 && centerResult) {
        that.view
          .goTo({
            target: results,
            zoom: Math.max(that.view.zoom, level),
          })
          .then(() => {
            if (jumpPoints?.length > 0 && !noJump) {
              that.startJumpPoint(jumpPoints);
            }
            resolve({
              status: 0,
              message: "ok",
              result: results,
            });
            return;
          });
      } else if (jumpPoints?.length > 0) {
        //不显示到地图中心，则直接跳跃结果点位
        if (!noJump) {
          that.startJumpPoint(jumpPoints);
        }
      }
      resolve({
        status: 0,
        message: "ok",
        result: results,
      });
      return;
    });
  }

  private _findClusterPointAndJump(theClusterLayer: any, type: any, ids: any) {
    const jumpPoints = new Array<any>();
    //显示到地图中心后需要等待该点graphic添加到地图上
    setTimeout(async () => {
      for (let i = 0; i < theClusterLayer.graphics.length; i++) {
        let graphic = theClusterLayer.graphics.getItemAt(i);
        if (graphic.attributes.isClusterText) {
          continue;
        }
        if (graphic.attributes && graphic.attributes.type == type && ids.indexOf(graphic.attributes.id) >= 0) {
          jumpPoints.push(graphic);
        }
      }
      await this.startJumpPoint(jumpPoints);
    }, 800);
  }

  private getLayerIds(layer: any): any[] {
    let layerids = [];
    if (layer.type == "feature") {
      //featurelayer查询
      layerids.push(layer.layerId);
    } else if (layer.type == "map-image") {
      let sublayers = (layer as __esri.MapImageLayer).allSublayers;
      sublayers.forEach(sublayer => {
        if (sublayer.visible) {
          layerids.push(sublayer.id);
        }
      });
    }
    return layerids;
  }

  private getLayerScale(label: string, layerId: number): any {
    let scale = 0;
    let resLayer: any;
    let parentlayer: any;
    let minScale = 0;
    let maxScale = 0;
    let allLayers = this.view.map.allLayers;
    for (let i = 0; i < allLayers.length; i++) {
      let layer = allLayers.getItemAt(i) as any;
      if (layer.type == "map-image" && layer.label == label) {
        let sublayers = (layer as __esri.MapImageLayer).allSublayers;
        sublayers.forEach((sublayer: any) => {
          if (sublayer.id == layerId) {
            resLayer = sublayer;
            parentlayer = layer;
          }
        });
        break;
      } else if (layer.type == "feature" && layer.label == label) {
        if (layer.layerId == layerId) {
          resLayer = layer;
          parentlayer = layer;
          break;
        }
      }
    }
    if (resLayer) {
      minScale = resLayer.minScale;
      maxScale = resLayer.maxScale;
      if (resLayer.minScale == 0 && resLayer.maxScale == 0 && resLayer.parent) {
        minScale = resLayer.parent.minScale == undefined ? 0 : resLayer.parent.minScale;
        maxScale = resLayer.parent.maxScale == undefined ? 0 : resLayer.parent.maxScale;
      }
    }
    scale = Utils.getMostScale(this.view, maxScale, minScale);
    return { layer: parentlayer, scale: scale };
  }

  //使toolTip中支持{字段}的形式
  private getContent(attr: any, content: string): string {
    let tipContent = content;
    if (content) {
      //键值对
      for (let fieldName in attr) {
        if (attr.hasOwnProperty(fieldName)) {
          tipContent = tipContent.replace("{" + fieldName + "}", attr[fieldName]);
        }
      }
    }
    let reg = /\{.*?\}|Null/g;
    tipContent = tipContent.replace(reg, "");
    return tipContent;
  }

  private async doFindTask(options: any): Promise<any> {
    type MapModules = [
      typeof import("esri/Graphic"),
      typeof import("esri/tasks/FindTask"),
      typeof import("esri/tasks/support/FindParameters"),
      typeof import("esri/geometry/SpatialReference"),
      typeof import("esri/tasks/support/Query"),
      typeof import("esri/tasks/QueryTask")
    ];
    const [Graphic, FindTask, FindParameters, SpatialReference, Query, QueryTask] = await (loadModules([
      "esri/Graphic",
      "esri/tasks/FindTask",
      "esri/tasks/support/FindParameters",
      "esri/geometry/SpatialReference",
      "esri/tasks/support/Query",
      "esri/tasks/QueryTask",
    ]) as Promise<MapModules>);
    let ids = options.ids;
    let type = options.layer.type;
    let showPopUp = options.showPopUp;
    let fields = options.fields;
    let symbol = {
      type: "simple-fill", // autocasts as new SimpleFillSymbol()
      color: [51, 51, 204, 0],
      style: "solid",
      outline: {
        color: [0, 255, 255, 255],
        width: 1,
      },
    }; //options.layer.renderer.symbol;
    let that = this;
    let res: any[] = [];
    let offset = options.offset;

    let graphics: any[] = [];
    let results: any;
    let select: any;
    for (let i = 0; i < ids.length; i++) {
      let searchText = ids[i];
      let findTask = new FindTask(options.url); //创建属性查询对象
      let findParams = new FindParameters(); //创建属性查询参数
      findParams.returnGeometry = true; // true 返回几何信息
      // findParams.layerIds = [0, 1, 2]; // 查询图层id
      findParams.layerIds = options.layerIds; // 查询图层id,todo
      findParams.contains = false;
      findParams.searchFields = ["DEVICEID", "BM_CODE", "FEATUREID", "SECTIONID", "ID", "Id"]; // 查询字段 artel
      findParams.searchText = searchText; // 查询内容 artel = searchText

      // 执行查询对象
      let data = await findTask.execute(findParams);
      //添加属性
      // if (type == "map-image") {
      //   let query = new Query();
      //   query.where = `id = ${ids}`;
      //   query.returnGeometry = true;
      //   var mapImageLayer = new QueryTask({
      //     url: options.url, // 替换为您的MapImageLayer服务的URL
      //   });
      //   console.log(mapImageLayer, 1111111);
      //   let data = await mapImageLayer.execute(query);
      //   console.log(data.features, "1112");

      //   // mapImageLayer.createQuery = query;
      // }
      results = data.results;
      if (results.length < 1) continue;

      const feats = results.map(async (item: any) => {
        let gra = item.feature;
        gra.symbol = symbol;
        // gra.symbol = await this.makeSymbol(lineStyle)
        graphics.push(gra);
        return item.feature;
      });
      select = that.getLayerScale(options.layer.label, results[0].layerId);

      if (select.layer && options.layer.isArrow) {
        that.showAnimateLine({
          features: graphics,
          layerIndex: options.layerIndex,
        });
      } else {
        if (ids.length < 2) {
          that.startHighlightOverlays(graphics[0].geometry, options?.hightLightOption?.color, options?.hightLightOption?.style, options?.hightLightOption?.width, options?.hightLightOption?.fillcolor, options?.hightLightOption);
        }
      }

      if (showPopUp) {
        if (ids.length > 1) {
          that.showCustomTip(select.layer, results[0].layerId, results[0].feature, fields);
        } else {
          that.showPopUp(select.layer, results[0].layerId, graphics[0], fields);
        }
      }
      if (select.layer && select.layer.showBar) {
        that.showSubBar(select.layer, graphics[0]);
      }
      if (select.layer && select.layer.showMigrate) {
        that.showSubwayChart(select.layer, graphics[0]);
      }
      if (select.layer && options.layer.isFlow) {
        that.showFlowLine({
          features: graphics,
          chartOption: { symbolSize: 6, color: "white" },
          url: select.layer.url + "/" + select.layer.layerId,
        });
      }

      res.push(feats);
    }
    if (ids.length > 1) {
      that.view.goTo({
        target: graphics,
      });
    } else if (graphics.length > 0) {
      if (options.zoom > 0) {
        that.view.goTo({
          target: offset.x == 0 && offset.y == 0 ? graphics[0].geometry : that.setOffset(Utils.getGeometryPoint(graphics[0].geometry), offset),
          zoom: options.zoom,
        });
      } else {
        let geometry = options.factor ? graphics[0].geometry.extent.clone().expand(options.factor) : graphics[0].geometry;
        if (select && select.scale == 0) {
          if (geometry.type == "polyline") {
            that.view.goTo({
              target: Utils.getGeometryPoint(geometry),
              zoom: options.zoom || that.view.zoom,
            });
          } else {
            that.view.goTo({
              target: offset.x == 0 && offset.y == 0 ? geometry : that.setOffset(Utils.getGeometryPoint(graphics[0].geometry), offset),
            });
          }
        } else {
          that.view.goTo({
            target: offset.x == 0 && offset.y == 0 ? geometry : that.setOffset(Utils.getGeometryPoint(graphics[0].geometry), offset), //,
            scale: select.scale,
          });
        }
      }
    }
    return res;
  }

  private setOffset(point: any, offset: { x: number; y: number }) {
    let np = point.clone();
    np.longitude = point.longitude + offset.x;
    np.latitude = point.latitude + offset.y;
    return np;
  }

  private showSubBar(layer: any, graphic: any) {
    if (layer && layer.showBar) {
      let point = graphic.geometry;
      let attr = graphic.attributes;
      this.view.popup.alignment = "bottom-center";
      //console.log(res.feature);
      let inField, inField2;
      let outField, outField2;
      if (layer.barFields) {
        inField = layer.barFields.inField;
        outField = layer.barFields.outField;
        inField2 = (inField.split(".").pop() as string) || inField;
        outField2 = (outField.split(".").pop() as string) || outField;
      }
      this.showBarChart({
        points: [
          {
            geometry: {
              x: point.x,
              y: point.y,
              spatialReference: this.view.spatialReference,
            },
            fields: {
              inflow: attr[inField] || attr[inField2] || attr["IN_FLX_NR"] || attr["VOLUME_YESTERDAY"] || attr["YJZH.STAT_METROLINEFLOW.VOLUME_YESTERDAY"],
              outflow: attr[outField] || attr[outField2] || attr["OUT_FLX_NR"] || attr["VOLUME_TODAY"] || attr["YJZH.STAT_METROLINEFLOW.VOLUME_TODAY"],
            },
          },
        ],
        name: "地铁线路图",
      });
    } else {
      this.view.popup.alignment = "auto";
    }
  }

  private showSubwayChart(layer?: any, feature?: any) {
    if (layer && layer.showMigrate) {
      let attr = feature.attributes;
      let id = "";
      for (let field in attr) {
        if (field.indexOf("FEATUREID") > -1 || field.indexOf("DEVICEID") > -1 || field.indexOf("SECTIONID") > -1) {
          id = attr[field];
        }
      }
      this.showODChart({
        id: id,
        type: layer.odtype,
        label: layer.label,
        url: layer.url + "/" + layer.layerId,
      });
    } else {
      this.showODChart(undefined);
    }
  }

  public showFlowLine(params: any) {
    const flow = SubwayLine.getInstance(this.view);
    flow.showSubwayFlow(params);
  }

  public showBarChart(params: any) {
    const chart = Bar3DChart.getInstance(this.view);
    chart.showBarChart(params);
  }

  public async showODChart(params: any) {
    const chart = MigrateChart.getInstance(this.view);
    chart.showODChartByLayer(params);
  }

  public async showAnimateLine(params: { features: Array<any>; layerIndex?: number }) {
    const flow = ArrowLineLayer.getInstance(this.view as __esri.MapView);
    flow.initialize(params);
  }

  private showCustomTip(layer: any, layerid: number, graphic: any, fields?: any) {
    let popup;
    if (!layer.popupTemplates && !layer.popupTemplate) {
      return;
    }
    if (layer.type == "map-image") {
      popup = layer.popupTemplates[layerid];
    } else if (layer.type == "feature") {
      popup = layer.popupTemplate;
    }
    let attrs = Utils.copyObject(graphic.attributes);
    for (let field in attrs) {
      let fieldArr: string[] = field.toString().split(".");
      let newfield = fieldArr.pop() as string;
      if (!attrs.hasOwnProperty(newfield)) {
        attrs[newfield] = attrs[field] !== undefined && attrs[field] !== null ? attrs[field].toString().replace("Null", "") : "";
      }
    }
    for (let str in fields) {
      attrs[str] = fields[str];
    }
    if (popup) {
      let content = this.getContent(attrs, popup.content);
      let toolTip = new ToolTip(
        this.view,
        {
          title: "",
          istip: true,
          yoffset: graphic.geometry.type == "point" ? 40 : 10,
          content: content,
        },
        Utils.getGeometryPoint(graphic.geometry)
      );
      this.tooltips.push(toolTip);
    }
  }

  private showPopUp(layer: any, layerid: number, graphic: any, fields?: any) {
    let popup;
    if (!layer.popupTemplates && !layer.popupTemplate) {
      return;
    }
    if (layer.type == "map-image") {
      popup = layer.popupTemplates[layerid];
    } else if (layer.type == "feature") {
      let layOpt = (this.view as any).mapConfig.operationallayers.find((opt: any) => {
        if (opt.label == layer.label && opt.url == layer.url + "/" + layer.layerId) {
          return true;
        }
      });
      popup = layOpt.popupTemplate;
    }
    let attrs = Utils.copyObject(graphic.attributes);
    for (let field in attrs) {
      let fieldArr: string[] = field.toString().split(".");
      let newfield = fieldArr.pop() as string;
      if (!attrs.hasOwnProperty(newfield)) {
        attrs[newfield] = attrs[field] !== undefined && attrs[field] !== null ? attrs[field].toString().replace("Null", "") : "";
      }
    }
    for (let str in fields) {
      attrs[str] = fields[str];
    }
    if (popup) {
      this.view.popup.open({
        title: popup.title,
        content: this.getContent(attrs, popup.content),
        location: Utils.getGeometryPoint(graphic.geometry),
      });
    }
  }

  private async startJumpPoint(graphics: any[]) {
    if (this.view.type == "3d") {
      let high = HighFeauture3D.getInstance(this.view as __esri.SceneView);
      high.startup(graphics);
    } else {
      let high = HighFeauture2D.getInstance(this.view as __esri.MapView);
      high.startup(graphics);
    }
  }

  public async startHighlightOverlays(geometry: any, color?: any, style?: string, width?: number, fillcolor?: string, hightLightOption?: any) {
    if (this.highTime) {
      clearTimeout(this.highTime);
      this.highTime = undefined;
    }
    if (!this.findLayer) {
      await this.createOverlayLayer();
    } else {
      this.findLayer.removeAll();
      this.view.popup.close();
    }
    this.highState = false;
    this.highCount = 0;
    if (geometry == undefined) {
      return;
    }
    this.highState = true;
    type MapModules = [typeof import("esri/Graphic")];
    const [Graphic] = await (loadModules(["esri/Graphic"]) as Promise<MapModules>);
    let symbol;
    // if (geometry.type == "polyline") {
    //   symbol = {
    //     type: "simple-line",
    //     color: color || [255, 255, 255],
    //     style: style || "dash",
    //     width: width || 6,
    //   };
    // } else if (geometry.type == "polygon") {
    // symbol = {
    //   type: "simple-fill",
    //   color: fillcolor || [255, 255, 255, 0],
    //   // color: [37, 85, 139, 0.5],
    //   style: "solid",
    //   outline: {
    //     color: color || [0, 0, 0],
    //     style: style || "short-dash",
    //     width: width || 3,
    //   },
    // };
    symbol = await this.makeSymbol(hightLightOption);
    // } else if (geometry.type == "point") {
    //   symbol = {
    //     type: "simple-marker",
    //     color: [255, 0, 0],
    //     style: "circle",
    //     size: 25,
    //     outline: {
    //       color: [255, 255, 255],
    //       style: "solid",
    //       width: 1.5,
    //     },
    //   };
    // }
    let highGraphic = new Graphic({
      geometry: geometry,
      symbol: symbol as any,
      attributes: {
        id: "highlight", //用于标识highlight图示
        type: "highlight",
      },
    });
    this.findLayer.add(highGraphic);
    // this.HighlightOverlays();
  }

  private step = -0.1;

  //要素高亮闪烁
  private HighlightOverlays() {
    let _this = this;
    this.highTime = setTimeout((e: any) => {
      if (_this.findLayer.opacity === 0) {
        this.step = 0.1;
        _this.highCount++;
      } else if (_this.findLayer.opacity === 1) {
        this.step = -0.1;
        _this.highCount++;
      }
      _this.findLayer.opacity = _this.findLayer.opacity + this.step;
      if (_this.highState && _this.highCount < _this.highRepeat) {
        _this.HighlightOverlays();
      } else {
        _this.findLayer.removeAll();
        _this.view.popup.close();
      }
    }, 100);
  }

  public stopHightlightFeature(): void {
    if (this.highTime) {
      clearTimeout(this.highTime);
      this.highTime = undefined;
      this.findLayer.removeAll();
      this.view.popup.close();
    }
  }
  private async getColor(c: Array<number> | string): Promise<Array<number>> {
    const [Color] = await loadModules(["esri/Color"]);
    let nc = new Color(c);
    return [nc.r, nc.g, nc.b, (nc.a * 255) % 256];
  }
  private async makeSymbol(symbol: IPointSymbol | undefined): Promise<Object | undefined> {
    if (!symbol || (symbol.type && symbol.type.toLowerCase() == "point-3d")) return undefined;
    let result;
    if (symbol.type == "arrow") {
      let lineColor = symbol.color ? await this.getColor(symbol.color) : [0, 100, 0, 255];
      let arrowColor = symbol.arrow && symbol.arrow.color ? await this.getColor(symbol.arrow.color) : [255, 255, 255, 255];
      let lineSize: number = (symbol.width || symbol.size || 6) as number;
      let arrowSize = (symbol.arrow && symbol.arrow.size) || lineSize - 1;
      lineSize = Math.max(lineSize, arrowSize); //取线和箭头的最大值
      result = {
        type: "cim",
        data: {
          type: "CIMSymbolReference",
          symbol: {
            type: "CIMLineSymbol",
            symbolLayers: [
              {
                type: "CIMVectorMarker",
                enable: true,
                size: arrowSize,
                markerPlacement: {
                  type: "CIMMarkerPlacementAlongLineSameSize",
                  endings: "Custom",
                  placementTemplate: [(symbol.arrow && symbol.arrow.space) || 14],
                  offsetAlongLine: 2,
                },
                frame: {
                  xmin: -lineSize,
                  ymin: -lineSize,
                  xmax: lineSize,
                  ymax: lineSize,
                },
                markerGraphics: [
                  {
                    type: "CIMMarkerGraphic",
                    geometry: {
                      paths: [
                        [
                          [-lineSize - 2, lineSize - 1],
                          [0, 0],
                          [-lineSize - 2, -lineSize + 1],
                        ],
                      ],
                    },
                    symbol: {
                      type: "CIMLineSymbol",
                      symbolLayers: [
                        {
                          type: "CIMSolidStroke",
                          enable: true,
                          color: arrowColor,
                          width: (symbol.arrow && symbol.arrow.width) || 2,
                        },
                      ],
                    },
                  },
                ],
              },
              {
                type: "CIMSolidStroke",
                enable: true,
                width: symbol.width || symbol.size || 6,
                color: lineColor,
              },
            ],
          },
        },
      };
    }
    return result;
  }
}
